import { OrganizationRoute } from "#routes/organization";
import { RoutePath } from "#utils/route";

export const FlowListRoute = OrganizationRoute.concat(
  new RoutePath({
    path: "/flows",
    title: "flow_plural",
  })
);
